export const frequency = {
	ONE_TIME: 'One time',
	REGULAR_EVERY_5_HOURS: 'Every 5 hours',
	REGULAR_EVERY_DAY: 'Every 1 day',
	REGULAR_EVERY_7_DAYS: 'Every 7 days',
	REGULAR_EVERY_30_DAYS: 'Every 30 days',
}
export const frequencyOpts = [
	{
		label: frequency.ONE_TIME,
		value: 'ONE_TIME',
	},
	{
		label: frequency.REGULAR_EVERY_5_HOURS,
		value: 'REGULAR_EVERY_5_HOURS',
	},
	{
		label: frequency.REGULAR_EVERY_DAY,
		value: 'REGULAR_EVERY_DAY',
	},
	{
		label: frequency.REGULAR_EVERY_7_DAYS,
		value: 'REGULAR_EVERY_7_DAYS',
	},
	{
		label: frequency.REGULAR_EVERY_30_DAYS,
		value: 'REGULAR_EVERY_30_DAYS',
	},
]
